/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Auth } from "aws-amplify";
import { MANAGER_ROLE, ADMIN_ROLE } from "./constants";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "./errorCodes";
import { fetchUserRoles } from "./permissions";
import { getUserById } from "../modules/settingsManager/services/UserService";

const COMPONENT_NAME = "Admin utility/auth";

export const getUserJwt = async () => (await Auth.currentSession()).getIdToken().getJwtToken();

export const getAuthHeader = async () => ({ Authorization: await getUserJwt() });

export const getLoggedInUserData = async () => {
	try {
		const user = await Auth.currentAuthenticatedUser();

		const email = user.attributes.email;

		const userId = user.attributes.sub;

		const roles = (await getUserById(email)).roles;

		const permission = await fetchUserRoles(roles);
		return { email, roles, userId, permission };
	} catch (error) {
		v2.warn("Could not get logged in user data", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.USER_DATA_GET_WARNING,
		});
		return { roles: [], email: "", userId: "" };
	}
};

export const getLoggedInUserEmail = async () => {
	const user = await Auth.currentAuthenticatedUser();
	return user?.attributes?.email;
};

export const isManager = (roles) => roles && roles.length > 0 && roles.includes(MANAGER_ROLE);

export const isAdmin = (roles) => roles && roles.length > 0 && roles.includes(ADMIN_ROLE);

export const getRoleDisplay = (roles) => {
	if (isAdmin(roles)) {
		return "Administrator";
	}

	if (isManager(roles)) {
		return "Manager";
	}

	return roles.length ? roles[0] : "Unknown role";
};
